<!-- 归属业务选择 -->
<template>
  <div class="fan-search-col content">
    <span class="source_span" v-if="title">{{title}}</span>
    <el-cascader
      ref="sourceRef"
      v-model="selectList"
      :options="sourceList"
      :size="formSize"
      collapse-tags
      :props="bindCascaderProps()"
      @change="changeBusiSource"
      v-bind="$attrs"
      v-on="$listeners"
    >
    </el-cascader>
  </div>
</template>

<script>
import { recursiveTree } from '@/utils/tools';
import { getSourceOfUser } from '@/api/global';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    sourceProps: {
      type: Object,
      default: () => ({}),
    },
    sources: {
      type: [String, Array],
      default: '',
    },
  },
  data() {
    return {
      sourceList: [
        {
          id: '',
          categoryNum: '-1',
          categoryName: '全部',
        },
      ],
      selectList: ['-1'],
      shareScopeEnd: [['-1']],
    };
  },
  watch: {
    sources: {
      handler(newV) {
        // 重置
        if (!newV || (Array.isArray(newV) && newV.length === 0)) {
          this.selectList = ['-1'];
          this.shareScopeEnd = [['-1']];
        }
      },
    },
  },
  created() {
    this._getSourceOfUser();
  },
  methods: {
    bindCascaderProps() {
      return {
        multiple: true,
        value: 'categoryNum',
        label: 'categoryName',
        // ...this.sourceProps,
      };
    },
    async _getSourceOfUser() {
      // 归属业务接口
      const res = await getSourceOfUser();
      const list = recursiveTree(res?.data || [], 0);
      this.sourceList = [...this.sourceList, ...(list || [])];
    },
    // 归属业务切换事件
    changeBusiSource(newValue) {
      if ((newValue && newValue.length === 0) || (newValue[0][0] === '-1' && newValue.length > 2 && this.shareScopeEnd.length > 2)) {
        this.selectList = ['-1'];
        this.shareScopeEnd = [['-1']];
        this.$emit('select-change', []);
        return;
      }
      const nodeList = this.$refs.sourceRef.getCheckedNodes();
      this.selectList = newValue;
      const selectData = [];
      nodeList.forEach((item) => {
        if (item.value !== '-1') {
          selectData.push(item.data.categoryNum);
        }
      });
      this.selectList = newValue.filter((v) => v[0] !== '-1');
      this.shareScopeEnd = newValue.filter((v) => v[0] !== '-1');
      this.$emit('select-change', selectData);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-bottom: 0;
  margin-right: 32px;
}
.el-cascader {
  min-width: 285px;
}
</style>
